export default __webpack_public_path__ + "static/media/delete-icon.bed8c76b.svg";